import { lazy } from "react";

export const CreatorsCatalogue = lazy(() => import("./CreatorsCatalogue"));
export const CatalogueDetails = lazy(() => import("./CatalogueDetails"));
export const AgencyInvite = lazy(() => import("./AgencyInvite"));
